import ServitechLogo from './svg/ServiTechColor.svg'


export default function TodoComponent(props) {
    const handleGoBack = () => {
        window.history.back();
    }

    return (
        <header id="navbar-header">
            <div className="ST-navbar">
                <div style={{ display: "flex" }}>
                    <div
                        className="col-auto me-auto center-txt"
                        style={{ justifyContent: "left" }}
                    >
                        <div className="logo-div">
                            <img
                                src={ServitechLogo}
                                alt="ServiTech Logo"
                                height="36rem"
                            />
                        </div>
                    </div>
                    <div
                        className="col-8 center-txt"
                        style={{ justifyContent: "center" }}
                    >
                        <div className="navbar-title">
                            <p className="bold-text service-title">Supplies Order Form</p>
                        </div>
                    </div>
                    <div className="col-auto ms-auto center-txt menu">
                        <button
                            onClick={handleGoBack}
                            type="button"
                            className="back-link"
                        >
                            <p className="bold-text">Back</p>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    )
}


